const WelcomeVideo = ({ videoSrc }) => (
    <div className="tab-content shadow-dark border-radius-0-2" id="v-pills-tabContent">
        <div className="tab-pane fade show position-relative active border-radius-0-2" id="cam1" role="tabpanel" aria-labelledby="cam1" style={{ height: "400px" }}>
            <video autoPlay muted loop playsInline className="w-100 h-100 border-radius-0-2" style={{ objectFit: "cover" }}>
                <source src={videoSrc} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
);

export default WelcomeVideo;